<script>
    export default {
        data() {
            return {
                isLoaded: false,
                isFullyLoaded: false
            };
        },
        mounted() {
            setTimeout(() => {
                this.isLoaded = true;

                setTimeout(() => {
                    this.isFullyLoaded = true;
                }, 500)
            }, 500);
        },
        methods: {
            logout(event) {
                event.preventDefault();
                event.stopPropagation();
                document.getElementById('logout-form').submit();
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../../../../sass/variables";

    .wrapper {
        display: flex;
    }
</style>
